export default __webpack_public_path__ + "static/media/article.29f73322.png";